import {IconButton, TableCell, TableRow, Typography} from "@mui/material";
import {useRef} from "react";
import {ToDateTimeDefault} from "@shared/MathHelp.ts";
import {Download, FileDownloadOff} from "@mui/icons-material";
import {useArquivo} from "@components/shared/arquivos/hooks/useArquivo.tsx";
import {IArquivoData} from "@components/shared/dto/IArquivoData.ts";
import {UsuarioTypo} from "@components/usuario/UsuarioTypo.tsx";
import {Imagem} from "@components/shared/arquivos/Imagem.tsx";

interface ArquivoProps {
    value: IArquivoData,
}

const imagesTypes = [
    'jpg',
    'png',
    'jpeg',
    'gif',
]

export function ArquivoRow(props: ArquivoProps) {
    const {value} = props
    const {getArquivo} = useArquivo()

    const downloadRef = useRef<HTMLAnchorElement>(null)

    const handleDownload = () => {
        if (downloadRef.current) {
            downloadRef.current.click();
            return;
        }

        getArquivo({id: value.id})
            .then((x) => {
                const url = URL.createObjectURL(x);

                const link = document.createElement('a');
                link.href = url;
                link.download = `${value.guid}.${value.extensao}`;
                link.click();

                downloadRef.current = link;

                setTimeout(() => {
                    downloadRef.current?.remove();
                    URL.revokeObjectURL(url);
                }, 25000)
            })
    }
    const broken = value.caminhoCompleto == null || value.caminhoCompleto.length <= 1;
    const isImage = imagesTypes.includes(value.extensao) || value.prefixo.startsWith('data:image/');

    return (<TableRow>
        <TableCell>
            {value.nome}
        </TableCell>
        <TableCell>
            <UsuarioTypo usuarioId={value.usuarioCriacaoId}/>
        </TableCell>
        <TableCell>
            <Typography>{ToDateTimeDefault(value.dataCriacao)}</Typography>
        </TableCell>
        <TableCell>
            <Typography>{value.extensao}</Typography>
        </TableCell>
        <TableCell>
            {value.tipo}
        </TableCell>
        <TableCell>
            {isImage && <Imagem size={'thumbnail'} value={value}/>}
        </TableCell>
        <TableCell>
            <IconButton
                disabled={broken}
                onClick={() => {
                    handleDownload()
                }}>
                {broken ? <FileDownloadOff/> :
                    <Download/>
                }
            </IconButton>
        </TableCell>
    </TableRow>)
}
